import { has } from "../../../../../utils/menu-context";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refPersonType"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refPersonType != null;
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "firstNameTh", 
                    "lastNameTh",
                    "idLine",
                    "refEducation",
                    "refMainOccupation",
                    "refSecondOccupation"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refTitle",
                    "birthDate",
                    "refNationality",
                    "refRace",
                    "refGender",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return !["1"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft"],
                })({ initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
        },
        {
            check: ({ field }) => {
                return ["idCard"].includes(field?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft"],
                })({ initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
        },
        {
            check: ({ field }) => {
                return ["registerDate", "registerCapital", "refCompanyType", "companyNameTh"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyType"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return ["1"].includes(modelRef.refPersonType?.key);
            },
            inputPropField: ({ initialModel, props }) => {
                const { viewOnly } = props;
                const common = commonInputPropField({
                    disabledStatuses: [undefined, "draft"],
                })({ initialModel });
                if (common.disabled !== true) {
                    common.disabled = viewOnly;
                }
                return common;
            },
        },
        {
            check: ({ field }) => {
                return ["positionCode", "refPosition", "refDepartment", "refSubDepartment","attachmentDocs.0"].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.isOfficer === true;
            },
        },
        {
            check: ({ field }) => {
                return ["expireDate"].includes(field?.key);
            },
            visibleField: ({ modelRef, data }) => {
                return ["2"].includes(modelRef.refPersonType?.key) || "PEOPLE" === data.registerType;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "cardIdCard",
                    "cardSignature",
                ].includes(field?.key);
            },
            visibleField: (/* { data } */) => {
                return false;
            },
        },
    ];
};

export const commonInputPropField =
({ disabledStatuses }) =>
({ initialModel }) => {
    let enabled = undefined;
    if (disabledStatuses.includes(initialModel.refStatus?.key)) {
        enabled = false;
    }
    return { disabled: enabled !== undefined ? !enabled : undefined };
};
